import { Autocomplete, Box, TextField } from "@mui/material";
import { UUID } from "crypto";

const Ad = ({ ad }: { ad: any }) => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Autocomplete
        id="combo-box-demo"
        onInputChange={ad.AdsData.handleSearchChange}
        options={
          ad.AdsData.AdsData
            ? [
                ...(ad.AdsData.AdsData?.map(
                  (ad: { name: string; id: string | UUID }) => ({
                    label: ad.name,
                    uid: ad.id,
                  })
                ) ?? []),
              ]
            : []
        }
        sx={{
          width: "100%",
        }}
        value={ad.state}
        loading={ad.AdsData.adsLoading}
        onChange={ad.handleChangeAd}
        isOptionEqualToValue={(option, value) => option.label === value?.label}
        renderInput={(params) => (
          <TextField {...params} label="Find Ad" variant="outlined" />
        )}
      />
    </Box>
  );
};

export default Ad;
